import { AxiosResponse, axios } from '~/modules'
import { IFetchPropertyMeasurementHistoryParams, ILaboratoryTestProperty } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

const _fetchQuantitativePropertyMeasurementHistory = async (
  url: string,
  queryParams: IFetchPropertyMeasurementHistoryParams['queryParams']
): Promise<ILaboratoryTestProperty[]> => {
  const response = await axios.get(url, { params: { ...queryParams } })
  const { data }: AxiosResponse<ILaboratoryTestProperty[]> = response
  return data
}

export const fetchQuantitativePropertyMeasurementHistory = async (
  params: IFetchPropertyMeasurementHistoryParams
): Promise<ILaboratoryTestProperty[]> => {
  const { pathParams, queryParams } = params
  const url = `${hstoryAPI}/patients/${pathParams.patientId}/laboratory-test-property-history`
  return await _fetchQuantitativePropertyMeasurementHistory(url, queryParams)
}
